<template functional>
  <i
    class="vsm-icon"
    :class="$options.methods.mergeFunctionalRenderContextClasses(data, props.src)"
  />
</template>

<script>
import { mergeFunctionalRenderContextClasses } from '@/helpers/utils'

export default {
  functional: true,

  props: {
    src: {
      type: String,
      required: true
    }
  },

  methods: {
    mergeFunctionalRenderContextClasses
  }
}
</script>
